import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const LookForAgeActiveSvg = ({ size = 24 }) => (
  <SvgWrapper size={size}>
    <defs>
      <linearGradient
        id="csi1nimoca"
        x1="-5.868%"
        x2="49.879%"
        y1="-44.938%"
        y2="72.987%"
      >
        <stop offset="0%" stopColor="#F98009" />
        <stop offset="99.945%" stopColor="#FED576" />
      </linearGradient>
      <linearGradient
        id="wv7k9af23b"
        x1="29.168%"
        x2="75.761%"
        y1="24.772%"
        y2="56.967%"
      >
        <stop offset="0%" stopColor="#F2999E" />
        <stop offset="100%" stopColor="#E06065" />
      </linearGradient>
      <linearGradient
        id="7mjft21tkc"
        x1="50%"
        x2="50%"
        y1="-45.49%"
        y2="133.711%"
      >
        <stop offset="0%" stopColor="#9FB1E1" />
        <stop offset="100%" stopColor="#6679BF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(1 2)">
      <g>
        <path
          fill="url(#csi1nimoca)"
          d="M0 5h22v12c0 1.657-1.343 3-3 3H3c-1.657 0-3-1.343-3-3V5z"
          transform="translate(0 1.608)"
        />
        <path
          fill="url(#wv7k9af23b)"
          d="M3 0h16c1.657 0 3 1.343 3 3v4H0V3c0-1.657 1.343-3 3-3z"
          transform="translate(0 1.608)"
        />
      </g>
      <path
        stroke="url(#7mjft21tkc)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M16 0L16 3.903M6 0L6 3.903"
      />
      <rect width="5" height="5" x="14" y="13.608" fill="#FFF" rx="1" />
    </g>
  </SvgWrapper>
)
